import { useState, useCallback } from 'react';
import { backendGet } from '../services/dataService';

export const useCustomerSearch = () => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const searchCustomers = useCallback(async (query) => {
    if (!query || query.length < 2) {
      setCustomers([]);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const data = await backendGet('data/customers/search', {
        label: 'Kundensuche',
        setIsLoading: setLoading,
        options: {
          params: { q: query, limit: 20 }
        }
      });
      
      if (data) {
        setCustomers(data);
      } else {
        setCustomers([]);
        setError('Keine Kunden gefunden');
      }
    } catch (err) {
      console.error('Customer search failed:', err);
      setError('Fehler beim Suchen der Kunden');
      setCustomers([]);
    }
  }, []);

  const clearSearch = useCallback(() => {
    setCustomers([]);
    setError(null);
  }, []);

  return {
    customers,
    loading,
    error,
    searchCustomers,
    clearSearch
  };
};
